// eslint-disable-next-line import/prefer-default-export
export const BLOG_POSTS_PAGINATION_PAGE_SIZE = 5;
export const RESOURCE_LIBRARY_PAGINATION_PAGE_SIZE = 12;
export const NEWS_POSTS_PER_CATEGORY_ON_INDEX = 4;
export const NEWS_POSTS_PAGINATION_PAGE_SIZE = 10;
